


document.addEventListener('DOMContentLoaded', () => {

  /* ===============================
     UTIL FUNCTIONS
  =============================== */

  function applyGrid(gridType) {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;

    productGrid.classList.toggle('grid-medium', gridType === 'medium');
  }

  function restoreGrid() {
    const gridType = sessionStorage.getItem('gridType') || 'medium';
    applyGrid(gridType);

    // Restore active button state
    document.querySelectorAll('.two-row-btn, .one-row-btn').forEach(btn => {
      btn.classList.toggle('is-active', btn.value === gridType);
    });
  }

  /* ===============================
     BUTTON CLICK (Mobile + Desktop)
  =============================== */

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.two-row-btn, .one-row-btn');
    if (!button) return;

    const wrapper = button.closest('.mbl-grid-btn, .dsk-grid-btn');
    if (!wrapper) return;

    wrapper.querySelectorAll('.two-row-btn, .one-row-btn')
      .forEach(btn => btn.classList.remove('is-active'));

    button.classList.add('is-active');

    const gridType = button.value; // medium / default
    sessionStorage.setItem('gridType', gridType);
    applyGrid(gridType);
  });

  /* ===============================
     INITIAL LOAD
  =============================== */

  restoreGrid();

  /* ===============================
     OBSERVE FILTER AJAX RERENDER
  =============================== */

  const gridContainer =
    document.querySelector('#ProductGridContainer') ||
    document.querySelector('.product-grid') ||
    document.body;

  const observer = new MutationObserver(() => {
    restoreGrid();
  });

  observer.observe(gridContainer, {
    childList: true,
    subtree: true
  });

});



// function handleRemoveButtonClick(event) {
//   // Prevent default action and stop event propagation
//   event.preventDefault();
//   event.stopPropagation();

//   // Store the reference to the clicked button
//   var clickedButton = $(this);
//   var clickedCartItem = clickedButton.closest('.cart-item');
//   var clickedCartItemName = clickedCartItem.find('.cart-item__name').text().trim();
//   var clickedVariantId = clickedCartItem.attr('data-variant-id');  // Get the clicked variant ID

//   console.log('Clicked cart item name (without Price Adjustment): ' + clickedCartItemName);

//   // Array to store all matched variant IDs (including the clicked one)
//   var matchedVariantIds = [];

//   // Loop through all cart items and match titles
//   $('.cart-item').each(function() {
//     var otherCartItemName = $(this).find('.cart-item__name').text().replace(/Price Adjustment/g, '').trim();
//     var otherVariantId = $(this).attr('data-variant-id');  // Get the variant ID of the current item

//     // If the product name matches the clicked product's name, store its variant ID
//     if (otherCartItemName === clickedCartItemName) {
//       matchedVariantIds.push(otherVariantId);  // Add the matching product's variant ID
//       console.log('Matching cart item found with variant ID: ' + otherVariantId);
//     }
//   });

//   console.log('Match Found: ' + matchedVariantIds);

//   // Check if there are matched variants (including the clicked one)
//   if (matchedVariantIds.length > 0) {
//     console.log('Matched variants to remove:', matchedVariantIds);

//     // Run a single AJAX request to remove all matched variants from the cart
//     $.ajax({
//       url: '/cart/update.js',  // Shopify's cart update endpoint
//       method: 'POST',
//       data: {
//         updates: matchedVariantIds.reduce((updates, variantId) => {
//           updates[variantId] = 0;  // Set quantity to 0 for each matched variant
//           return updates;
//         }, {})
//       },
//       dataType: 'json',
//       success: function(response) {
//         console.log('Cart updated successfully:', response);

//         var currentPageUrl = window.location.href;

//         // Make an AJAX request to get the updated page content
//         $.ajax({
//             url: currentPageUrl,
//             type: 'GET',
//             success: function(response) {
//                 // Use DOMParser to parse the response HTML
//                 var parser = new DOMParser();
//                 var doc = parser.parseFromString(response, 'text/html');
    
//                 // Find the specific elements in the parsed document
//                 var updatedItems = doc.querySelector('cart-drawer.drawer').innerHTML;
//                 var updatedCartCount = doc.querySelector('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').innerHTML;
    
//                 // Update the existing elements on the page with the updated content
//                 $('cart-drawer.drawer').html(updatedItems);
//                 $('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').html(updatedCartCount);
//                 if(doc.querySelector('.cart-icon-wrapper .cart-count-bubble > span[aria-hidden="true"]').innerText == '(0)') {
//                   $('cart-drawer.drawer').addClass('is-empty');
//                 }

//                 setTimeout(function() {
//                   $('cart-remove-button .button').off('click');
//                   $('cart-remove-button .button').on('click', handleRemoveButtonClick);
//                 }, 1500);
               
//             },
//             error: function(xhr, status, error) {
//                 console.error('Error fetching updated cart drawer content:', error);
//             }
//         });

//         // Trigger the remove action on the clicked product after the matched products are removed
//         // clickedButton.off('click').trigger('click');
//       },
//       error: function(error) {
//         console.error('Error updating cart:', error);
//       }
//     });
//   } else {
//     // No matches found, just trigger the remove action for the clicked product
//     clickedButton.off('click').trigger('click');
//   }

//   setTimeout(function() {
//     $('cart-remove-button .button').off('click');
//     $('cart-remove-button .button').on('click', handleRemoveButtonClick);
//   }, 2500);
  
// }


$(document).ready(function() {

  if($('body').hasClass('template-product')) {

      $('.product-form__buttons button[type="submit"]').click(function(event) {
        
        var checkInputField = $('.input-box-main input[type="text"]').val();
        var $this = $(this);
        if(checkInputField != '' && !$(this).hasClass('success')) {
          console.log('API Script Run');
          event.preventDefault();
          $('.load-more').attr('style', 'display: flex;');
          var getProTitle = $('.product__title h1').text();
          getProTitle = `${getProTitle}`;
          var getProImg = $('.main-prod-slider .thumbnail-img .swiper-slide-active .image-wrap img').attr('src');
          var getProPrice = $('.price__sale .price-item--sale').text();
          var numericValue = parseFloat(getProPrice.match(/[\d.]+/)[0]);
          var proPacks = $('.packk-blk .pack-qty').text();
          var proM = $('.packk-blk .fp-require-area').text();
          var totalPackPrice = numericValue * proPacks;
          totalPackPrice = totalPackPrice.toFixed(2);
          var totalAreaPrice = numericValue * proM;
          totalAreaPrice = totalAreaPrice.toFixed(2);
          // var finalPrice = totalAreaPrice - totalPackPrice;
          var finalPrice = totalAreaPrice;
          // finalPrice = finalPrice.toFixed(2);

          var data = {
              title: getProTitle,
              price: finalPrice,
              img: getProImg
          };
          
          $.ajax({
              url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-create-product',
              method: 'POST',
              contentType: 'application/json',
              headers: {
                  'Authorization': 'Bearer YOUR_ACCESS_TOKEN'
              },
              data: JSON.stringify(data)
          })
          .done(function(response) {
              if (response.product_id && response.variant_id) {
                  console.log('Product created successfully:');
                  console.log('Product ID:', response.product_id);
                  console.log('Variant ID:', response.variant_id);

                  $('.load-more').hide();
                  $('.product-form:not(.sample-btn) .product-variant-id').val(response.variant_id);
                  $('.product-form:not(.sample-btn) input[name="properties[Packs]"]').remove();
                  $('.product-form:not(.sample-btn) form').prepend(`<input type="hidden" name="properties[Packs]" value="${$('.packk-blk .pack-qty').text()}">`);
                  $('.product-form:not(.sample-btn) #Quantity').val('1');
                  $this.addClass('success');
                  $this.click();
                  Cookies.set('productAPI', 'cookieValue', { expires: 1 });
                
              } else {
                  console.log('Product created, but no IDs returned:', response.message);
              }
          })
          .fail(function(jqXHR, textStatus, errorThrown) {
              console.error('Failed to create product:', textStatus, errorThrown);
          });
          
        } else {
          $this.removeClass('success');
            // setTimeout(function() {
            //   $('cart-remove-button .button').on('click', handleRemoveButtonClick);
            // }, 2500);
        }
        
      });
    
  }

  $.getJSON('/cart.js', function(cart) {
      if (cart.item_count === 0) {
          console.log("The cart is empty.");
          if (Cookies.get('productAPI')) {
              console.log('productAPI Cookie exists!');
              $.ajax({
                url: 'https://ukflooringdepot.gearhikes.com/api/custom-api-delete-product-TZ',
                method: 'POST',  // Change to POST if necessary
                headers: {
                    'Authorization': 'Bearer YOUR_ACCESS_TOKEN',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function(response) {
                    console.log('Success:', response.message);
                    Cookies.remove('productAPI');
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error('Error:', textStatus, errorThrown);
                }
            });
          } else {
              console.log('productAPI Cookie does not exist.');
          }
      } else {
          console.log("The cart has items.");
      }
  });

  
  
  // Attach the custom click handler to the remove button
  // $('cart-remove-button .button').on('click', handleRemoveButtonClick);



  
});














document.addEventListener('DOMContentLoaded', () => {
  const SAMPLE_VARIANT_ID = '57045349499264'; // Change if different variants
  const MAX_SAMPLES = 3;
  const MESSAGE = 'You can only add a maximum of 3 samples to your cart.';

  async function getSampleCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const sampleItem = cart.items.find(i => i.variant_id.toString() === SAMPLE_VARIANT_ID);
      return sampleItem ? sampleItem.quantity : 0;
    } catch (e) {
      return 0;
    }
  }

  // Target "Order a Sample" buttons (adjust selector if needed)
  document.querySelectorAll('button:contains("Order a Sample"), .product-form__submit span:contains("Order a Sample")').forEach(btn => {
    btn.closest('form')?.addEventListener('submit', async (e) => {
      const form = e.target;
      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || variantInput.value !== SAMPLE_VARIANT_ID) return;

      const current = await getSampleCount();
      if (current >= MAX_SAMPLES) {
        e.preventDefault();
        e.stopPropagation();

        // Try theme's error display, fallback to alert
        const notification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (notification?.renderError) {
          notification.renderError(MESSAGE);
        } else {
          alert(MESSAGE);
        }
      }
    });
  });
});